export default __webpack_public_path__ + "static/media/reset-password-v2.1e72e41a.svg";